import styled from 'styled-components';
import { CssFuncs } from '../../../foundation/css/css.funcs';

const Container = styled.div.withConfig({
  componentId: 'node-item-action-button_container',
  displayName: 'NodeItemActionButton.Container',
})`
  ${CssFuncs.css.size({ xy: '18px' })}
  ${CssFuncs.css.asAbsoluteContainer()}
`;

const SnoozeItem = styled.div.withConfig({
  componentId: 'node-item-action-button_snooze-item',
  displayName: 'NodeItemActionButton.SnoozeItem',
})`
  z-index: 2;
  ${CssFuncs.css.size({ xy: '18px' })};
  ${CssFuncs.css.absolute({ xy: '0px' })}

  ${Container}:hover & {
    display: none;
  }
`;

const CheckItem = styled.div.withConfig({
  componentId: 'node-item-action-button_check-item',
  displayName: 'NodeItemActionButton.CheckItem',
})`
  z-index: 1;
  ${CssFuncs.css.size({ xy: '18px' })};
  ${CssFuncs.css.absolute({ xy: '0px' })}

  ${Container}.snooze-enabled:not(:hover) & {
    display: none;
  }
`;

export const NodeItemActionButtonStyle = {
  Container,
  SnoozeItem,
  CheckItem,
};
